<template>
  <asyncModalButton
    v-bind="$attrs"
    v-on="$listeners"
    :tooltipLabel="getTooltipLabel"
    :disabled="disabled">
    <template v-slot="{ hasPermission }">
      <b-icon
        :icon="actif ? 'archive' : 'archive-arrow-up'"
        :class="{ 'text-access-no-permission': !hasPermission }"
        type="is-default"/>
    </template>
  </asyncModalButton>
</template>

<script>
import asyncModalButton from './asyncModalButton';

export default {
  props: {
    actif: {
      type: Boolean,
      required: true,
    },
    tooltipLabel: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    asyncModalButton,
  },
  computed: {
    getTooltipLabel() {
      return this.tooltilLabel
        || (this.actif ? this.$t('general.button.archiver') : this.$t('general.button.desarchiver'));
    },
  },
};
</script>
